export const defaultLocaleKey = 'locale';

export class I18nLocaleStorage {
  public readonly localeKey = defaultLocaleKey;
  // Effective fallback: fallbackLanguage if it passes the allowlist, otherwise first allowed entry.
  private readonly safeFallback: string;

  constructor(
    public readonly fallbackLanguage: string,
    public readonly availableLanguages?: string[]
  ) {
    if (availableLanguages && !availableLanguages.includes(fallbackLanguage)) {
      this.safeFallback = availableLanguages[0] ?? fallbackLanguage;
    } else {
      this.safeFallback = fallbackLanguage;
    }
  }

  get() {
    const persisted = localStorage.getItem(this.localeKey);

    if (
      persisted &&
      (!this.availableLanguages || this.availableLanguages.includes(persisted))
    ) {
      return persisted;
    } else if (
      persisted &&
      this.availableLanguages &&
      !this.availableLanguages.includes(persisted)
    ) {
      this.clear();
    }

    return this.safeFallback;
  }

  set(locale: string) {
    if (locale === this.safeFallback) {
      this.clear();
    } else if (
      !this.availableLanguages ||
      this.availableLanguages.includes(locale)
    ) {
      localStorage.setItem(this.localeKey, locale);
    }
  }

  clear() {
    localStorage.removeItem(this.localeKey);
  }
}

export function getBrowserLanguage(fallback: string): string {
  return (
    (navigator.language || fallback).split('-')[0]?.toLowerCase() ?? fallback
  );
}
